import { defineNuxtPlugin } from 'nuxt/app'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('VSelect', vSelect)
})
